module.exports = __webpack_public_path__ + "static/media/logo-za-urbes.c4a2dd7f.png";